/* eslint-disable @next/next/no-img-element */
import Head from "next/head";
import React, { ReactElement, useEffect } from "react";
import { serverSideTranslations } from "../common/utility/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { GetStaticProps } from "next";
import { NotFoundUI } from "@kunduz/feature-website-common";

export default function FourOhFour(props): ReactElement {
  const { t, i18n } = useTranslation("kunduzcom_common");

  useEffect(() => {
    if (!i18n) return;

    i18n.changeLanguage(props.lang);
  }, [i18n]);

  return (
    <>
      <Head>
        <title>{t("404_page_title")}</title>
      </Head>

      <NotFoundUI
        title={t("404_page_title")}
        label={t("404_page_label")}
        backButtonLabel={t("404_page_go_back_button_label")}
        desc={t("404_page_description")}
        homeButtonLabel={t("404_page_go_homepage_button_label")}
      />
    </>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      lang: context.locale,
      ...(await serverSideTranslations(context.locale, ["kunduzcom_common"])),
    },
  };
};
